"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritScpiPartPiervalCorporationTrads = void 0;
exports.ESubDejaSouscritScpiPartPiervalCorporationTrads = {
    between_10_25: "Entre 10 et 25%",
    between_5_10: "Entre 5 et 10%",
    greater_than_25: "Plus de 25%",
    less_than_5: "Moins de 5%",
};
